import { render } from "./RequestDuedates.vue?vue&type=template&id=12417865"
import script from "./RequestDuedates.vue?vue&type=script&lang=js"
export * from "./RequestDuedates.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__